<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
    style="enable-background: new 0 0 200 200"
    xml:space="preserve"
  >
    <rect style="fill: #ffffff" width="200" height="200" />
    <g>
      <path
        style="fill: #9b5c8f"
        d="M60.5,72.8h81.4c5.2,0,9.3,4.2,9.3,9.3v31.1c0,5.2-4.2,9.3-9.3,9.3h-29.2l4,9.8l-17.6-9.8H60.6
		c-5.2,0-9.3-4.2-9.3-9.3V82.1C51.2,77,55.4,72.8,60.5,72.8z"
      />
      <path
        style="fill: #ffffff"
        d="M56.9,81.3c0.6-0.8,1.4-1.2,2.6-1.3c2.1-0.2,3.3,0.8,3.5,2.9c1.3,8.5,2.6,15.7,4.1,21.6l8.9-17
		c0.8-1.5,1.8-2.4,3-2.4c1.8-0.1,2.9,1,3.3,3.4c1,5.4,2.3,10,3.9,13.9c1.1-10.3,2.8-17.8,5.4-22.4c0.6-1.1,1.5-1.7,2.7-1.8
		c0.9-0.1,1.8,0.2,2.6,0.8c0.8,0.6,1.2,1.4,1.3,2.3c0,0.7-0.1,1.3-0.4,2c-1.6,2.9-2.9,7.8-3.9,14.7c-1,6.6-1.4,11.8-1.1,15.5
		c0.1,1-0.1,1.9-0.5,2.7c-0.5,0.9-1.2,1.4-2.2,1.5c-1.1,0.1-2.2-0.4-3.2-1.5c-3.8-3.9-6.8-9.6-9-17.3c-2.6,5.2-4.6,9.1-5.9,11.7
		c-2.4,4.6-4.4,7-6.1,7.1c-1.1,0.1-2-0.9-2.8-2.8c-2.1-5.3-4.3-15.6-6.7-30.9C56.1,82.9,56.4,82,56.9,81.3L56.9,81.3z M144.3,87.7
		c-1.5-2.6-3.6-4.1-6.5-4.7c-0.8-0.2-1.5-0.2-2.2-0.2c-3.9,0-7.1,2-9.6,6.1c-2.1,3.5-3.2,7.3-3.2,11.5c0,3.1,0.7,5.8,2,8
		c1.5,2.6,3.6,4.1,6.5,4.7c0.8,0.2,1.5,0.2,2.2,0.2c3.9,0,7.1-2,9.6-6.1c2.1-3.5,3.2-7.3,3.2-11.5C146.3,92.5,145.6,89.9,144.3,87.7
		L144.3,87.7z M139.2,98.9c-0.6,2.7-1.6,4.7-3.1,6c-1.2,1.1-2.3,1.5-3.3,1.3c-1-0.2-1.8-1.1-2.4-2.6c-0.5-1.3-0.7-2.5-0.7-3.7
		c0-1,0.1-2,0.3-3c0.4-1.7,1.1-3.3,2.2-4.8c1.3-2,2.8-2.8,4.2-2.5c1,0.2,1.8,1.1,2.4,2.6c0.5,1.3,0.7,2.5,0.7,3.7
		C139.5,97,139.4,98,139.2,98.9L139.2,98.9z M118.9,87.7c-1.5-2.6-3.7-4.1-6.5-4.7c-0.8-0.2-1.5-0.2-2.2-0.2c-3.9,0-7.1,2-9.6,6.1
		c-2.1,3.5-3.2,7.3-3.2,11.5c0,3.1,0.7,5.8,2,8c1.5,2.6,3.6,4.1,6.5,4.7c0.8,0.2,1.5,0.2,2.2,0.2c3.9,0,7.1-2,9.6-6.1
		c2.1-3.5,3.2-7.3,3.2-11.5C120.8,92.5,120.2,89.9,118.9,87.7L118.9,87.7z M113.7,98.9c-0.6,2.7-1.6,4.7-3.1,6
		c-1.2,1.1-2.3,1.5-3.3,1.3c-1-0.2-1.8-1.1-2.4-2.6c-0.5-1.3-0.7-2.5-0.7-3.7c0-1,0.1-2,0.3-3c0.4-1.7,1.1-3.3,2.2-4.8
		c1.3-2,2.8-2.8,4.2-2.5c1,0.2,1.8,1.1,2.4,2.6c0.5,1.3,0.7,2.5,0.7,3.7C114,97,113.9,98,113.7,98.9L113.7,98.9z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "IconWoo",
};
</script>
